import React from 'react';

import { ExecutionHistoryContext } from '@qality/common-components/src/lib/ExecutionHistoryProvider';
import { TestStep } from '@qality/common-model';
import { TestExecutionHistoryUtils } from '@qality/common-utils';

import { FailedStepsView } from './FailedSteps.view';

export const FailedSteps: React.FC<TestStep> = () => {
  // @ts-expect-error ImportTestCasesStatusContext is in plain JS
  const { failedSteps } = React.useContext(ExecutionHistoryContext);

  const openExecution = async (id: number) => {
    TestExecutionHistoryUtils.openTestExecutionInNewTab(id);
  };

  return (
    <FailedStepsView
      isLoading={!failedSteps}
      openExecution={openExecution}
      steps={failedSteps}
    />
  );
};
